<app-help-page mainVideo="conditional-dimensions"
               [tutorials]="['conditional-dimensions']"
               [videos]="['conditional-dimensions']"></app-help-page>
